module.exports = __webpack_public_path__ + "static/media/spec_residents.b495be1e.png";